const speedDial = {
  quickCreate: "Быстрое создание",
  aiAssistant: "AI Ассистент",
  search: "Поиск",
  newNote: "Новая заметка",
  timer: "Таймер",
  editMode: "Режим редактирования",
  doneEditing: "Готово",
  pickShortcut: "Выбрать ярлык",
  searchShortcuts: "Поиск...",
  pages: "Страницы",
  widgets: "Виджеты",
  entities: "Сущности",
  longPressToEdit: "Долгое нажатие для редактирования",
  emptySlot: "Пусто",
  removeSlot: "Удалить",
} as const;
export default speedDial;
